import { GraphRest } from "../rest.js";
import { Planner } from "./types.js";
import "./groups.js";
import "./users.js";
export { Bucket, Buckets, Plan, Planner, Plans, Task, Tasks, TaskDetails, PlanDetails, } from "./types.js";
Reflect.defineProperty(GraphRest.prototype, "planner", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return Planner(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map